import { render } from "./SelectTeamMemberModal.vue?vue&type=template&id=54c0b3c9&scoped=true&ts=true"
import script from "./SelectTeamMemberModal.vue?vue&type=script&lang=ts"
export * from "./SelectTeamMemberModal.vue?vue&type=script&lang=ts"

import "./SelectTeamMemberModal.vue?vue&type=style&index=0&id=54c0b3c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c0b3c9"]])

export default __exports__